<template>
  <Navbar />
  <div class="margin">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import Navbar from './components/Navbar.vue';
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.margin {
  margin-top: 120px;
  margin-bottom: 50px;
}
</style>
